module.exports = __webpack_public_path__ + "static/media/track-issue-icon.3c277b4d.png";